module.exports = __webpack_public_path__ + "static/media/itvLogo.5327329e.svg";